import React, { useState } from 'react'
import { Poppins, Quicksand } from 'next/font/google'
import Image from 'next/image';
import Link from 'next/link';
import EnrollForm from './enroll-form';
const popins = Poppins({weight:['500','600','700'],subsets:['latin'],display:'swap',preload:true});
const quickSand = Quicksand({weight:['400','500','600'],subsets:['latin'],display:'swap',preload:true});
export default function HeroSection({title,Intro,language,insights}) {
 
 const [formPopup,setFormPopup] = useState(false);

 const handlePopup = ()=>{
    setFormPopup(true);
 }

 const handleCloseForm = ()=>{
    setFormPopup(false)
 }

  
  return (
    <>
    <section className='bg-clr df fjc fac'>
       <div className='container df fdc fjc fac'>
        {/* <Breadcrumbs/> */}
        <h1 className={`fs-32 tfs-30 mfs-22 tac fwb600 mt24 ${popins.className}`}>{title}</h1>
       <p className={`fs-16 tfs-15 mfs-14 fwb600 mfwb400 mt24 mmt12 tac para-cnt ${quickSand.className}`} 
             dangerouslySetInnerHTML={{
              __html: Intro.replace(/in\${(.*?)}/g, function (match, p1) {
              }),
            }}></p>
      <div className='df gap24 mt12'>
        <div className='df gap11 fac'>
        <Image loading='eager' src={"/new-course-details/duration.svg"}  width={18} height={18} alt={`duration-Icon`} />
       <p className={`fs-16 mfs-15 fwb500 ${popins.className}`}> {language}</p>
        </div>
        <div className='df gap11 fac'>
        <Image  loading='eager'  src={"/new-course-details/certificate.svg"} width={18} height={18} alt={`Certificate-Icon`}/>
        <p className={`fs-16 mfs-15 fwb500 ${popins.className}`}> Certified Course</p>
        </div>
      </div>
       <div className='df mt32 tmt28 mmt24 gap32 '>
         <button onClick={handlePopup} className={`fs-16 mfs-15 ylw-clr fwb600 enrl-btn cw cursor ${popins.className}`}>Enroll Now</button>
        {/* <Link href={'tel:+917825888899'}> <button className={`fs-16 ylw-clr fwb600 mfs-15 call-btn cursor ${popins.className}`} style={{width:'200px'}}>Call Now </button> </Link> */}
        <Link legacyBehavior href="tel:+917825888899" passHref>
  <a className={`fs-16 ylw-clr fwb600 mfs-15 call-btn cursor tac ${popins.className}`} style={{width:'200px'}} >Call Now</a></Link>
       </div>
 
     {/* <p className={`fs-16 mfs-15 mt32 tmt28 mmt24 ${quickSand.className}`}>Top Companies That Hire  <strong>{title} </strong></p> */}
    {/* <div className='df gap43 fw fac fjc mt24'>
{topcompanyhire.map((img,index)=>{
    return(
      <div className='' key={index}>
       <Image  loading='eager' src={img} width={100} height={42} alt='Top-Companies' quality={100}/>
       </div>
    )
})}
   </div> */}
      </div>  
    </section>
    {insights &&   <section className="">
    <div className='rect-box df fjc fjse fac '>
      { insights.map((insight,index)=>{
        return(

               <><div className='df fdc fac' key={index}>
            <h5 className={`fs-20 tfs-18 mfs-16 fwb700 cw ${popins.className}`}>{`${insight.count} +`}</h5>
            <h6 className={`fs-16 mfs-15 mt24  cw fwb500 ${quickSand.className}`}>{insight.label}</h6>
          </div>
          {index+1<insights.length?<div className='liner-code'></div>:""}</>
                )
              })}
                </div>
                

    </section>}
    {formPopup && 
    (  
     <><div className="backdrop"></div><div className="popup">
                  <EnrollForm classType={true} message={true} course={`${title}`} closeForm={handleCloseForm} closeBtn={true}/>
              </div></>)}
    <style jsx>
        {`
              .para-cnt{
              width: 75%;
              }
                 .liner-code{
                    width:3px;
                    height:82px;
                    background: #fff;
                }
                  
                        .rect-box{
                  width:100%;
                  height:157px;
                  background-color:#FFA900;
                  text-align:center;
              
                 }
        .bg-clr{
background: #FDCF74;
background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 30%, rgba(253, 207, 116, 0.4) 70%);        width: 100%;
        height: auto;
        padding: 70px 0px;
        }
        .enrl-btn{
        background: #FFA900;
        border-radius: 10px;
        border:none;
        width: 194px;
        }
        .call-btn{
        background: #fff;
        border: none;
        border-radius: 10px;
        box-shadow: 0px 4px 16px 0px #00000040;
        padding: 5px 10px;
        }
        @media only screen and (min-width:768px) and (max-width: 1023px){

                .bg-clr{
        background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 30%, rgba(253, 207, 116, 0.4) 70%);
        width: 100%;
        height: auto;
        padding: 40px 0px;
        }
        }
        @media only screen and (max-width: 767px){
                .bg-clr{
        background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 30%, rgba(253, 207, 116, 0.4) 70%);
        width: 100%;
        height: auto;
        padding: 30px 0px;
        }
        .rect-box{
        display: none;
        }
         .para-cnt{
              width: 85%;
              }
             .call-btn{
        background: #fff;
        border: none;
        border-radius: 10px;
        box-shadow: 0px 4px 16px 0px #00000040;
        padding: 5px 10px;
        width: 100%;
        }
        }
        @media only screen and (max-width: 460px){

        .sfdc{
        flex-direction: column;
        gap: 18px;
        }
            .enrl-btn{
        background: #FFA900;
        border-radius: 10px;
        border:none;
        width: 120px;
        padding: 5px 0px;
        }
        .call-btn{
        width: 120px !important;
        }
        }
        `}
    </style>
    </>
  )
}
